export enum BeneficiaryDetailsStatusDescription {
  COUNT_DESC = 'Bezugsberechtigten festgelegt',
  PERCENTAGE_DESC = 'des Bezugsrechts verteilt',
  FROM = 'von',
  MAX_COUNT = 'max. 3',
  MAX_PERCENTAGE = '100%'
}

export const MAX_ENTITLEMENT_PERCENTAGE = 100;
